export class MainMenu {
    constructor() {
        const menuBtn = this.button
        const closeBtn = this.closeButton
        const overlay = this.overlay

        if(menuBtn) {
            this.addListeners(menuBtn, closeBtn, overlay)
        }
    }

    get button() {
        return document.querySelector('.header-btn')
    }

    get closeButton() {
        return document.querySelector('.main-menu__close')
    }

    get overlay() {
        return document.querySelector('.main-menu__overlay')
    }

    get menu() {
        return document.querySelector('.main-menu')
    }

    get subMenus() {
        return document.querySelectorAll('.toggle-sub-list')
    }

    addListeners(menuBtn, closeBtn, overlay) {
        menuBtn.addEventListener('click', e => {
            this.toggleMenu(this.menu)
        })

        closeBtn.addEventListener('click', e => {
            this.toggleMenu(this.menu)
        })

        overlay.addEventListener('click', e => {
            this.toggleMenu(this.menu)
        })

        for (let i = 0, l = this.subMenus.length; i < l; i ++) {
            this.subMenus[i].addEventListener('click', () => {
                this.toggleSubMenu(this.subMenus[i]);
            })
        }
    }

    toggleMenu(menu) {
        if(menu.classList.contains('shown')) {
            menu.classList.remove('shown')
        } else {
            menu.classList.add('shown')
        }
    }

    toggleSubMenu(subMenu) {
        const hasSub = subMenu.closest('.has-sub')

        if(hasSub.classList.contains('active')) {
            hasSub.classList.remove('active')
        } else {
            hasSub.classList.add('active')
        }
    }
}